export default "__VITE_ASSET__DiTQneu5__"